import React, { useState, useRef, useEffect } from 'react'

import "./solarcreateaccount.css"
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import { formatPhoneNumber } from 'react-phone-number-input';
import { useNavigate } from 'react-router-dom';
import { useAuthSolar } from '../../../setup/AuthContextSolar'
import { dbSolar, authSolar} from '../../../setup/FirebaseSolar';
import { getFirestore, doc, setDoc, addDoc, runTransaction, collection, onSnapshot } from "firebase/firestore";
import { getDatabase, ref, set, child, get, onValue } from "firebase/database";

export default function SolarCreateAccount() {


  const retryTaskWithBackoffUserData = async (task, maxRetries, retryDelay, currentRetry = 0) => {
    try {
      await task();
      return; // Task succeeded
    } catch (error) {
      if (currentRetry < maxRetries) {
        console.warn(`Retrying task (retry ${currentRetry + 1}/${maxRetries})...`);
        await new Promise(resolve => setTimeout(resolve, retryDelay));
        await retryTaskWithBackoffUserData(task, maxRetries, retryDelay, currentRetry + 1);
      } else {
        await authSolar.currentUser.delete();
        throw error;
      }
    }
  };
  
  const retryOptions = {
    maxRetries: 3,          // Maximum number of retries
    retryDelay: 1000,       // Delay in milliseconds between retries
  };


  const emailRef = useRef()
  // const phoneRef = useRef()
  const [phone, setPhone] = useState()
  const passwordRef = useRef()
  const companyRef = useRef()
  const nameRef = useRef()
  const consentRef = useRef()
  const confirmPasswordRef = useRef()
  const { signup, createProfile, logout } = useAuthSolar()
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [passwordsMatch, setPasswordsMatch] = useState(true);
  const navigate = useNavigate()

  async function handleSubmit(e) {
    e.preventDefault();
    if (!passwordsMatch) {
        setError('Passwords do not match');
        alert('Passwords do not match');
        return;
    }
    if (passwordRef.current.value.length < 6) {
      setError('Password must be at least 6 characters');
      alert('Password must be at least 6 characters')
      return;
    }
    try {
        setError('');
        setLoading(true);
        
        await signup(emailRef.current.value, passwordRef.current.value);
      
        await retryTaskWithBackoffUserData(async () => {
          await authSolar.currentUser.getIdToken(true);
        }, retryOptions.maxRetries, retryOptions.retryDelay);
      
        await retryTaskWithBackoffUserData(async () => {
          await createProfile(nameRef.current.value);
        }, retryOptions.maxRetries, retryOptions.retryDelay);

        navigate("/Solar-Subscribe")
    } catch (e) {
        console.log(e)
          if (e.code === "auth/email-already-in-use") {
            const message = "An account with this email already exists. Try logging in.";
            alert(message)
          } else {
            setError('Sign Up Failed');
            alert("Sign Up Failed");
          }
    } finally {
        setLoading(false);
    }
  }
  const handlePasswordChange = () => {
    setPasswordsMatch(passwordRef.current.value === confirmPasswordRef.current.value);
  };
  return (
    <div className='emas__clientsignup'>
      <div className='emas__clientsignup-container'>
        <h1>Create Solar Account</h1>
        <form onSubmit={handleSubmit}>
          <p>Client Name</p>
          <input ref={nameRef} type={"name"} placeholder="enter client name" required />
          <p>Company Name</p>
          <input ref={companyRef} type={"name"} placeholder="enter name (if applicable)" />
          <p>Email</p>
          <input ref={emailRef} type={"email"} placeholder="enter email" required />
          <p>Password</p>
          <input ref={passwordRef} type={"password"} placeholder="enter password" required onChange={handlePasswordChange}/>
          <input ref={confirmPasswordRef} type={"password"} placeholder="confirm password" required onChange={handlePasswordChange}/>
          <div className='emas__clientsignup-container_checks'>
            <div>
              <p>I agree to the EMAS <a href='/privacy-policy'>Privacy Policy</a></p><input type="checkbox" required/>
            </div>
            <div>
              <p>I wish to recieve emails when new publications are released.</p><input type="checkbox" ref={consentRef}/>
            </div>
          </div>
          {/* <div>


<StripeBuyButton />
          </div> */}

          <button disabled={loading} type="submit">{loading? "Loading..." : "Create"}</button>
        </form>
      </div>
    </div>
  )
}


